(function($) {

	/** Anchor link smooth scroll */

	$(".arrow-container a").on('click', function(event) {
		event.preventDefault();
		var hash = this.hash;
		$('html, body').animate({
			scrollTop: ( $(hash).offset().top -100 )
		}, 1000, 'swing' );
	});

// Owl Carousel
$(document).ready(function(){
    $("#testimonial-slider").owlCarousel({
        items:1,
        itemsDesktop:[1000,1],
        itemsDesktopSmall:[979,2],
        itemsTablet:[768,2],
        itemsMobile:[650,1],
        pagination:false,
        navigation:true,
        navigationText:["",""],
        autoPlay:true
    });
});

// Lightbox Gallery

$(document).on('click', '[data-toggle="lightbox"]', function(event) {
	event.preventDefault();
	$(this).ekkoLightbox({
		alwaysShowClose: true
	});
});

//Aos Animation

AOS.init({
	offset: 200,
	duration: 800,
	disable: 'mobile',
	easing: 'ease-in-quad',
	delay: 100,
  });

// Hamburger Toggle

$(document).ready(function () {
	$('.first-button').on('click', function () {
  
	  $('.animated-icon1').toggleClass('open');
	});
	
  });

  // DropDown Menu
  $('.dropdown').on('show.bs.dropdown', function(e){
	$(this).find('.dropdown-menu').first().stop(true, true).slideDown(300);
  });
  
  $('.dropdown').on('hide.bs.dropdown', function(e){
	$(this).find('.dropdown-menu').first().stop(true, true).slideUp(300);
  });

  // on Scroll logo resize
  /*  Header onscroll background-color */

  $(window).on('scroll', function() {
	if ($(this).scrollTop() >= 200) {
		$('.navbar').addClass('fixed-top');
	} else if ($(this).scrollTop() == 0) {
		$('.navbar').removeClass('fixed-top');
	}
});

function adjustNav() {
	var winWidth = $(window).width(),
		dropdown = $('.dropdown'),
		dropdownMenu = $('.dropdown-menu');
	
	if (winWidth >= 768) {
		dropdown.on('mouseenter', function() {
			$(this).addClass('show')
				.children(dropdownMenu).addClass('show');
		});
		
		dropdown.on('mouseleave', function() {
			$(this).removeClass('show')
				.children(dropdownMenu).removeClass('show');
		});
	} else {
		dropdown.off('mouseenter mouseleave');
	}
}

$(window).on('resize', adjustNav);

adjustNav();

})(jQuery);

